import useSWR from "swr";
import { MyChargeContractApi } from "../../../../apis";
import type { ChargeContract } from "../../../../apis/chargeContract";

/** Read-only SWR for the caller tenant's platform charge contract. */
export function useChargeContract() {
  const { data, error, isLoading, mutate } = useSWR("swr.my.charge-contract", () =>
    MyChargeContractApi.getMy()
  );
  return {
    contract: data as ChargeContract | null | undefined,
    error,
    isLoading,
    reload: () => mutate()
  };
}
